"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemsByUserExtraReducers = void 0;
const tslib_1 = require("tslib");
const __1 = require("../../..");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getItemsPayload_1 = require("../../../shared/getItemsPayload");
const getItemsByUser = toolkitRaw.createAsyncThunk('users/fetch_items', async (id, { rejectWithValue }) => {
    try {
        const response = await __1.api.get(`/api/market/users/${id}/items`);
        const payload = (0, getItemsPayload_1.getItemsDeserializeFromApi)(response);
        return { items: payload.data, ownerId: id };
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getItemsByUserExtraReducers = (builder) => {
    builder.addCase(getItemsByUser.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getItemsByUser.fulfilled, (state, action) => {
        var _a;
        state.loading = false;
        const index = (_a = state.data) === null || _a === void 0 ? void 0 : _a.findIndex((user) => user.ownerId === action.payload.ownerId);
        const stateItems = {
            ownerId: action.payload.ownerId,
            items: Array.from(action.payload.items),
        };
        if (index < 0) {
            state.data.splice(index, 0, stateItems);
        }
        else {
            state.data.push(stateItems);
        }
    });
    builder.addCase(getItemsByUser.rejected, (state) => {
        state.loading = false;
    });
};
exports.getItemsByUserExtraReducers = getItemsByUserExtraReducers;
exports.default = getItemsByUser;
//# sourceMappingURL=index.js.map